import script from "./VisualLayers.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualLayers.vue?vue&type=script&setup=true&lang=js"

export default script